import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useObs } from '../contexts/ObsContext';

/**
 * Guard for the observation screens.
 *
 * If there is no observation in progress — storage cleared, a link opened
 * directly, a session that has moved on — send the observer back to the start
 * rather than letting the screen render against nothing and fail on its first
 * API call.
 */
export default function useRequireObs() {
  const { obs } = useObs();
  const navigate = useNavigate();

  useEffect(() => {
    if (!obs?.id) {
      toast.info('That observation is no longer open. Start a new one.');
      navigate('/observe/context', { replace: true });
    }
  }, [obs?.id, navigate]);

  return obs;
}
